module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoUaeMoe.e1861d22.png";